export default __webpack_public_path__ + "static/media/sms.05e5720d.csv";